export default __webpack_public_path__ + "static/media/7shifts.bd02da28.png";